var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconService = function SvgIconService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9933 9.48145C21.9933 10.1494 21.4203 10.6727 20.771 10.6727H19.5487L19.5755 16.6139C19.5755 16.7178 19.5678 16.8143 19.5564 16.9145V17.5156C19.5564 18.3357 18.8727 19 18.0285 19H17.4174C17.3754 19 17.3334 18.9666 17.2913 18.9963C17.2379 18.9666 17.1844 19 17.1309 19H14.9728C14.1287 19 13.445 18.3357 13.445 17.5156V14.25C13.445 13.5932 12.8988 13.0625 12.2227 13.0625H9.77818C9.10211 13.0625 8.55591 13.5932 8.55591 14.25V17.5156C8.55591 18.3357 7.8722 19 7.02807 19H4.89291C4.83562 19 4.77832 18.9963 4.72103 18.9926C4.67519 18.9963 4.62936 19 4.58352 19H3.97239C3.12864 19 2.44455 18.3357 2.44455 17.5156V13.3594C2.44455 13.326 2.44569 13.2889 2.44798 13.2555V10.6727H1.22418C0.535508 10.6727 0 10.1494 0 9.48145C0 9.14746 0.114741 8.85059 0.382342 8.59082L10.1754 0.297469C10.4428 0.0371836 10.7484 0 11.0157 0C11.2831 0 11.5887 0.0743672 11.8217 0.260285L21.5731 8.59082C21.8787 8.85059 22.0353 9.14746 21.9933 9.48145Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconService, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_service.55666029.svg";
export { ForwardRef as ReactComponent };